import { ScAuthButtons } from 'components/auth/AuthButtons/styled';
import styled from 'styled-components';

export const ScMenuModal = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;

  ${ScAuthButtons} {
    grid-template-columns: 1fr 1fr;
  }
`;

export const ScTabbarDashboard = styled.div`
  display: grid;
  gap: 8px;
`;
